import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { LogIn } from 'lucide-react';

export const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    setLoading(false);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.error);
    }
  };

  return (
    <div data-testid="login-page" className="min-h-screen bg-parchment flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-parchment-dark p-8">
          <div className="flex items-center justify-center mb-8">
            <LogIn className="text-forest mr-3" size={32} />
            <h1 className="text-3xl font-bold text-forest" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
              Connexion
            </h1>
          </div>

          {error && (
            <div data-testid="login-error" className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <Label htmlFor="email" className="text-stone-800 font-medium mb-2 block">Email</Label>
                <Input
                  data-testid="login-email-input"
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="border-parchment-dark focus:ring-forest"
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-stone-800 font-medium mb-2 block">Mot de passe</Label>
                <Input
                  data-testid="login-password-input"
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className="border-parchment-dark focus:ring-forest"
                />
              </div>

              <Button
                data-testid="login-submit-button"
                type="submit"
                disabled={loading}
                className="w-full bg-forest text-white hover:bg-forest-light transition-colors py-6 text-base font-semibold"
              >
                {loading ? 'Connexion...' : 'Se connecter'}
              </Button>
            </div>
          </form>

          <div className="mt-6 text-center">
            <Link
              to="/register"
              data-testid="register-link"
              className="text-terracotta hover:text-terracotta-light transition-colors text-sm font-medium"
            >
              Pas encore de compte ? S'inscrire
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
